module.exports = __webpack_public_path__ + "img/icon_gzyl.9ce27062.png";